import { setSelectedTab } from "../App";
import AnimatedSpacing from "./AnimatedSpacing";
import './Projects.css';
import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Link } from 'react-router-dom';

import ls_main from '../assets/projects-assets/liteboxer/litesport-main.png';
import ls_homepage from '../assets/projects-assets/liteboxer/litesport-homepage.png';
import ls_st from '../assets/projects-assets/liteboxer/litesport-strength.png';
import ls_md from '../assets/projects-assets/liteboxer/litesport-mittdrills.png';
import ls_st_results from '../assets/projects-assets/liteboxer/litesport-strength-results.png';
import ls_tb from '../assets/projects-assets/liteboxer/litesport-totalbody.png';

import club_pilates_main from '../assets/projects-assets/club-pilates/clubPilatesCard.png';
import stretch_lab_main from '../assets/projects-assets/stretch-lab/stretchLabCard.png';
import pure_barre_main from '../assets/projects-assets/pure-barre/pureBarreMain.png'


class Projects extends React.Component {
    componentDidMount() {
        setSelectedTab('projects');
    }
    render(){
        return (
            <div className='subpage projectsPage'>
                <LiteboxerCard/>
                <ProjectSpacing/>
                <StretchLabCard/>
                <ProjectSpacing/>
                <PureBarreCard/>
                <ProjectSpacing/>
                <ClubPilatesCard/>
                <ProjectSpacing/>
                <Link
                className='projectsHeaderLink' 
                to={`/projects/personal`}>
                    personal projects {'\u2192'}
                </Link>
            </div>
        );
    }
}

export function ProjectHeaderSpacing() {
    return (
        <AnimatedSpacing spacingId='5' startHeight='7em' endHeight='4em'/>
    );
}

export function ProjectSpacing() {
    return (
        <AnimatedSpacing spacingId='1' startHeight='10em' endHeight='5em'/>
    );
}

function ClubPilatesCard() {
    return (
        <XPOProjectCard 
        title='Club Pilates' 
        mainImage={club_pilates_main} 
        description='Trainer-led Pilates workouts in XR' 
        websiteURL='https://www.clubpilates.com' 
        metaStoreUrl='https://www.meta.com/experiences/club-pilates/7725697200858646'/>
    );
}

function StretchLabCard() {
    return (
        <XPOProjectCard 
        title='Stretch Lab' 
        mainImage={stretch_lab_main} 
        description='Trainer-led stretching exercises in XR' 
        websiteURL='https://www.stretchlab.com' 
        metaStoreUrl='https://www.meta.com/experiences/stretchlab/7457571521021518'/>
    );
}

function PureBarreCard() {
    return (
        <XPOProjectCard 
        title='Pure Barre' 
        mainImage={pure_barre_main} 
        description='Barre classes in XR' 
        websiteURL='https://www.purebarre.com' 
        metaStoreUrl='https://www.meta.com/experiences/pure-barre/8245796978837572'/>
    );
}

function LiteboxerCard() {
    return (
        <ProjectCard title='Litesport' media={[
            <div key={0}>
                <img src={ls_main} alt='litesport main'/>
            </div>,
            <div key={1}>
                <img src={ls_st} alt='litesport st'/>
            </div>,
            <div key={2}>
                <img src={ls_md} alt='litesport md'/>
            </div>,
            <div key={3}>
                <img src={ls_homepage} alt='litesport homepage'/>
            </div>,
            <div key={4}>
                <img src={ls_st_results} alt='litesport results'/>
            </div>,
            <div key={5}>
                <img src={ls_tb} alt='litesport tb'/>
            </div>
        ]}
        description={[
            <div key={0}>Cutting-edge VR fitness on the Meta Quest platform, with a 4-star rating spanning <b style={{color:'#F79376'}}>1,900+</b> user reviews.</div>,
            <br key={3}/>,
            <a key={4} href='https://litesport.com/pages/vr' rel='noreferrer' target={'_blank'}>Official Litesport website</a>,
            <br key={5}/>,
            <br key={6}/>,
            <a key={7} href='https://www.oculus.com/experiences/quest/4175028349266073/' rel='noreferrer' target={'_blank'}>Meta Quest store page</a>
        ]}
        tags={[<div key={0}>C#</div>, <div key={1}>GO</div>, <div key={2}>SQL</div>, <div key={3}>Unity</div>, <div key={4}>Meta Quest</div>, <div key={4}>Android XR</div>, <div key={5}>HLSL</div>]}/>
    );
}

export class ProjectCard extends React.Component {
    render() {
        return (
            <div className='borderBox projectCard'>
                <Carousel className='mediaCarousel' showThumbs={false} dynamicHeight={true} showStatus={false}>
                    {this.props.media}
                </Carousel>
                <div className='description'>
                    <div>
                        <h3>{this.props.title}</h3>
                        <p>{this.props.description}</p>
                    </div>
                    <div className='tags'>{this.props.tags}</div>
                </div>
            </div>
        );
    }
}

export class XPOProjectCard extends React.Component {
    render() {
        return (
            <ProjectCard title={this.props.title} media={[
                <div key={0}>
                    <img src={this.props.mainImage} alt='main'/>
                </div>,
            ]}
            description={[
                <div key={0}>{this.props.description}</div>,
                <br key={3}/>,
                <a key={4} href={this.props.websiteURL} rel='noreferrer' target={'_blank'}>{this.props.title} website</a>,
                <br key={5}/>,
                <br key={6}/>,
                <a key={7} href={this.props.metaStoreUrl} rel='noreferrer' target={'_blank'}>Meta Quest store page</a>
            ]}
            tags={[<div key={0}>C#</div>, <div key={1}>GO</div>, <div key={2}>SQL</div>, <div key={3}>Unity</div>, <div key={4}>Meta Quest</div>, <div key={4}>Android XR</div>, <div key={5}>HLSL</div>]}/>
        );
    }
}

export default Projects;